import { render } from "./ModelView.vue?vue&type=template&id=92a33924&scoped=true"
import script from "./ModelView.vue?vue&type=script&lang=js"
export * from "./ModelView.vue?vue&type=script&lang=js"

import "./ModelView.vue?vue&type=style&index=0&id=92a33924&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92a33924"]])

export default __exports__